import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss']
})
export class AddressBookComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
